import styled from 'styled-components'
import { Grid } from '@material-ui/core'
import { px2rem } from '../../../../../theme/Global'

export const LocationAddressContainer = styled(Grid)`
  margin: 0 0 ${px2rem(22)}rem;
`
